export default __webpack_public_path__ + "static/media/img--design-4.d3cfcfe1.jpg";